import { useQuery } from "@tanstack/react-query";
import { companiesApi } from "@/api/companies";
import { queryKeys } from "@/lib/query-keys";

export function useCompanies() {
  return useQuery({
    queryKey: queryKeys.companies.all,
    queryFn: companiesApi.list,
  });
}

export function useCompany(id: string) {
  return useQuery({
    queryKey: queryKeys.companies.detail(id),
    queryFn: () => companiesApi.get(id),
    enabled: !!id,
  });
}
